// extracted by mini-css-extract-plugin
export default {"wrapper":"ShowTopics_wrapper__nuBhn","selectTopic":"ShowTopics_selectTopic__YmJms"};